export default "__VITE_ASSET__6f4d868e__"